import { Grid, Typography, Pagination } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import OrderCards from "../../../components/user/orderCards.js";
import useVendor from "../../../hooks/useVendor";

const CurrentOrder = () => {
  const {
    CurrentOrderReducers: { currentOrder: allCurrentOrder },
  } = useSelector((state) => state);

  const { ofVendor } = useVendor();
  const currentOrder = ofVendor(allCurrentOrder);

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(2);
  let firstIndex = 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <Box display="flex" mt="35px" flexDirection="column">
        <Typography mb="25px" variant="t24_600">
          Current Orders
        </Typography>

        {!currentOrder.length ? (
          <Typography mb="25px" textAlign="center" variant="t20_400">
            No Current Orders
          </Typography>
        ) : (
          <Grid container spacing={2} >
            <Grid item xs={12} md={true}>
              <Grid container spacing={2}>
                {currentOrder.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page).map((d) => (
                  <Grid key={d.nID} item xs={12} sm={6} xl={6}>
                    <OrderCards value={d} type={'currentOrder'}/>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Box>
      {currentOrder.length > 2 &&
        <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
          <Pagination
            size="large"
            shape="rounded"
            color='primary'
            count={Math.ceil(currentOrder?.length / rowsPerPage)}
            page={page}
            onChange={handleChangePage}
            siblingCount={1}
          />
        </Box>
      }
    </>
  );
};

export default CurrentOrder;
